export default "__VITE_ASSET__CTCxxbVD__"